<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";

/** @type {{ row: any, column: any }} */
let { row, column } = $props();

let value = $derived(row?.[column?.id] ?? "");
let isExpanded = $derived(
    eventGroupState[projectState.selected]?.selected?.[0] ===
        row?.originalIndex,
);
</script>

<span class="text-cell" class:is-expanded={isExpanded} title={value}>{value}</span>

<style>
.text-cell {
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: text;
    cursor: text;
}
.text-cell.is-expanded {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    text-overflow: clip;
}
</style>
